import { FaRegUserCircle, FaUnlockAlt } from 'react-icons/fa';
import './header.scss';
import logo from '../../resources/images/logo_zkratka.png';
import React, { useEffect } from 'react';
import { useAppState } from '../../hooks';
import { ECathegory, EPage, EUserType, TUser } from '../../types';
import { getUserWithoutDetail } from '../../api';
import { GiPodiumWinner } from "react-icons/gi"
import { TbMessage, TbSettings, TbZoomFilled } from "react-icons/tb"

type HeaderProps = {
    handleLoginModalOpen: any,
    setPage: any,
    page: EPage
}


export const Header = ({ handleLoginModalOpen, setPage, page }: HeaderProps) => {
    const { state } = useAppState()
    const [user, setUser] = React.useState<TUser | undefined>(undefined)

    useEffect(() => {
        if (state?.token) {
            getUserWithoutDetail({ token: state.token }).then((response) => {
                if (response.user) {
                    setUser(response.user)
                }
            })
        } else {
            setUser(undefined)
        }
    }, [state?.token])

    const headerColor = () => {
        if (user && user.Cathegory) {
            switch (user.Cathegory) {
                case ECathegory.Z: return 'blue'
                case ECathegory.P: return 'red'
            }
        }
        return ''
    }


    return <div className={'header ' + headerColor()}>
        <div className='header__logo'>
            <img src={logo} alt="Logo" className='header__logo'/>
        </div>
        <div className='header__menu'>
            <div className='header__menu__item'>
                <FaUnlockAlt size={50} color={page == EPage.WEBYSTEM ? 'black' : 'grey'} onClick={() => setPage(EPage.WEBYSTEM)} />
            </div>
            <div className='header__menu__item'>
                <GiPodiumWinner size={50} color={page == EPage.STATS ? 'black' : 'grey'} onClick={() => setPage(EPage.STATS)} />
            </div>
            <div className='header__menu__item'>
                <TbMessage size={50} color={page == EPage.HISTORY ? 'black' : 'grey'} onClick={() => setPage(EPage.HISTORY)} />
            </div>
            {user?.Type == EUserType.ADMIN
                ?
                    <div className='header__menu__item'>
                        <TbSettings size={50} color={page == EPage.ADMIN ? 'black' : 'grey'} onClick={() => setPage(EPage.ADMIN)} />
                    </div>
                : <></>
            }
            {user?.Type == EUserType.ADMIN
                ?
                <div className='header__menu__item'>
                    <TbZoomFilled size={50} color={page == EPage.OVERVIEW ? 'black' : 'grey'} onClick={() => setPage(EPage.OVERVIEW)} />
                </div>
                : <></>
            }
        </div>
        <div className='header__login'>
            {user
                ?
                <>
                    <img className='header__login__avatar' src={`https://eu.ui-avatars.com/api/?background=fff8e5&color=000&name=${user.Name}`} alt='profil' onClick={handleLoginModalOpen} title='Detail týmu' />
                </>
                :
                <>
                    <FaRegUserCircle fontSize='3rem' onClick={handleLoginModalOpen}/>
                </>
            }
        </div>
       
    </div>
}